import { ProgressBar } from '@shopflo/ui'
import React from 'react'
import { PreviewCartItem } from 'src/lib/contexts/CartLayoutContext'

interface MilestoneProps {
  cartItems: PreviewCartItem[]
  progressBar: { isEnabled: boolean }
  customizations: any
  milestones: any
  isCountBased: boolean
}

export const Milestone: React.FC<MilestoneProps> = ({
  cartItems,
  progressBar,
  customizations,
  milestones,
  isCountBased
}) => {
  const total = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0)

  const itemCount = cartItems.reduce((acc, item) => acc + item.quantity, 0)

  if (!progressBar.isEnabled) return null

  return (
    <ProgressBar milestones={milestones} customizations={customizations} total={isCountBased ? itemCount : total} />
  )
}
